import { AppointmentBookingStep } from "../types";

export const AppointmentBookingStepSet = new Set(Object.values(AppointmentBookingStep));

export const BOOKING_STEPS = [
  AppointmentBookingStep.Start,
  AppointmentBookingStep.Pets,
  AppointmentBookingStep.Reason,
  AppointmentBookingStep.DateTime,
  AppointmentBookingStep.Review,
];
